module.exports = __webpack_public_path__ + "static/freshman-5-e4d2e20fdb872f8db46ae49fe566e78a.jpg";